import { authStore } from 'shared/security/AuthStore';

const CURRENT_USER_REF = 'current_user';

export function serializeUserRef(user, currentUserId) {
	if (!user) return null;
	if (user.id === currentUserId) {
		return { ref: CURRENT_USER_REF };
	}
	return {
		id: user.id,
		name: user.name,
		imageUrl: user.imageUrl
	};
}

export function serializeUserRefs(users, currentUserId) {
	if (!users?.length) return null;
	return users.map(user => serializeUserRef(user, currentUserId));
}

export function resolveUserRef(ref, currentUser) {
	if (!ref) return null;
	if (ref.ref === CURRENT_USER_REF) {
		return currentUser ? { ...currentUser } : null;
	}
	if (ref.id != null) {
		return {
			id: ref.id,
			name: ref.name,
			imageUrl: ref.imageUrl
		};
	}
	return null;
}

export function resolveUserRefs(refs, currentUser) {
	if (!refs?.length) return null;
	return refs.map(ref => resolveUserRef(ref, currentUser)).filter(Boolean);
}

export function getCurrentUserId() {
	return authStore.profile?.id ?? null;
}

export function getCurrentUser() {
	return authStore.profile ?? null;
}

export function normalizeUserRefForCompare(ref) {
	if (!ref) return null;
	if (ref.ref === CURRENT_USER_REF) return { ref: CURRENT_USER_REF };
	if (Array.isArray(ref)) {
		const normalized = ref
			.map(item => normalizeUserRefForCompare(item))
			.filter(Boolean);
		return normalized.length ? normalized : null;
	}
	if (ref.id == null) return null;
	return { id: ref.id };
}
